import { useQuery } from "@tanstack/react-query";
import { listMyConnectors } from "@/api/connectors";
import { queryKeys } from "@/api/query-keys";

/**
 * The user's connected MCP servers, for the composer's connectors picker.
 * Shares the query key (and so the cache) with settings' management hook —
 * the read fn lives in `api/` because features can't import each other.
 */
export function useMyConnectors() {
  return useQuery({
    queryKey: queryKeys.connectors.mine(),
    queryFn: listMyConnectors,
    staleTime: 30_000,
  });
}
